import { render, staticRenderFns } from "./BLAdjustments.vue?vue&type=template&id=785321b3&"
import script from "./BLAdjustments.vue?vue&type=script&lang=js&"
export * from "./BLAdjustments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports